<template>
    <div>
        <div v-if="internalData" v-html="internalData">
      <!-- The content will be inserted here as raw HTML -->
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import api from '@/api'
export default {
    data() {
        return {
            internalData: null,
            error: null,
        };
    },
	async created () {
        console.log("Created")
		this.getData();
	},
	methods:{
        async getData () {
            console.log("gettingdata")
            /*data.data.session=this.getCookie("session");
            data.data.userid=this.getCookie("userid");
            data.data.user=this.getCookie("user");*/

            api.getProxy('proxy/wechatlink/').then((res) => {
                this.internalData = res.data;
            })
            .catch(error => {
                this.error = error.response ? error.response.data.message : error.message;
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/Proxy.vue